module.exports = __webpack_public_path__ + "media/images/people/girl-7-d6363f23d4784ef5e02b13da860e042c.webp";